/* ==========================================================================
   Homepage Hero Slider — lichte, eigen crossfade-slider.
   Geen externe library nodig: simpele class-toggle + autoplay + dots + pijlen.
   ========================================================================== */

(function () {
  'use strict';

  var AUTOPLAY_DELAY = 7500;

  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('[data-hotpot-hero-slider]');

    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll('[data-hotpot-hero-slide]');
      var dots = slider.querySelectorAll('[data-hotpot-hero-dot]');
      var prevBtn = slider.querySelector('[data-hotpot-hero-prev]');
      var nextBtn = slider.querySelector('[data-hotpot-hero-next]');

      if (slides.length <= 1) return;

      var currentIndex = 0;
      var timer = null;

      function goTo(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;

        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === currentIndex);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(function () {
          goTo(currentIndex + 1);
        }, AUTOPLAY_DELAY);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(currentIndex - 1);
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(currentIndex + 1);
          restartAutoplay();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          restartAutoplay();
        });
      });

      startAutoplay();
    });
  });
})();